export default __webpack_public_path__ + "static/charging-lockers-18eb4dd7398954f0a05855422436bda7.jpg";